import { SessionService } from './SessionService';
import { environment } from './../../environments/environment';
import { ErrorHandler } from './../common/error/error-handler';
import { Http, RequestOptions, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ExportService {

    private url: string;

    constructor(private http: Http, private session: SessionService) {
        this.url = environment.api.myshiftUrl + '/timesheets/';
    }

    process(exportFilter) {
        const options = new RequestOptions({ headers: this.session.getHeaders() });
        return this.http.post(this.url + 'export', JSON.stringify(exportFilter), options)
            .map(response => response);
    }

    processSite(exportFilter) {
        const options = new RequestOptions({ headers: this.session.getHeaders() });
        return this.http.post(this.url + 'exportSite', JSON.stringify(exportFilter), options)
            .map(response => response);
    }
    maxDay() {
      return this.http.get(this.url + 'maxDays').map(response => response);
    }
}



// WEBPACK FOOTER //
// ./src/app/service/export.service.ts